import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BacnetPoint} from '../../shared/models/point';
import {HttpClient} from '@angular/common/http';
import {TUNNEL_BASE_URL} from './env.service';
import { DeviceId } from 'src/shared/models/device';

@Injectable({
  providedIn: 'root',
})
export class PointsService {
  lastDeviceDiscovered: DeviceId;
  discoveryCache: { [deviceId: DeviceId]: BacnetPoint[] } = {};


  constructor(
    private http: HttpClient,
  ) {
  }


  /**
   * After initiating discovery, unsubscribe to the returned observable to abort
   * before normal completion.
   *
   * @param deviceId
   * @param timeout
   */
  public discoverPoints$(deviceId: DeviceId, timeout: number = 40): Observable<BacnetPoint[]> {
    return new Observable((s) => {
      const sub = this.http.get<BacnetPoint[]>(`${TUNNEL_BASE_URL}/remote/point-discovery/device/${deviceId}`, {
        headers: {
          'x-motion-hubd-timeout': `${timeout}`,
        },
      }).subscribe(
        (data) => {
          this.lastDeviceDiscovered = deviceId;
          this.discoveryCache[deviceId] = data;
          s.next(data);
          s.complete();
        }, (err) => {
          this.lastDeviceDiscovered = deviceId;
          this.discoveryCache[deviceId] = [];
          s.error(err);
        },
      );

      return () => {
        sub.unsubscribe();
      };
    });
  }
}
